import { render, staticRenderFns } from "./Controlables.view.vue?vue&type=template&id=4a021af0"
import script from "./Controlables.view.vue?vue&type=script&lang=js"
export * from "./Controlables.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports